import type { SessionClient } from "@phurshell/psiapp-frontend-core/domain";
import {
  ApiServiceImpl,
  AxiosHttpClient,
  createAxiosClient,
} from "@phurshell/psiapp-frontend-core/infra";
import { SessionClientAdapter } from "@/app/adapters/SessionClientAdapter";
import {
  authTokenStorageClient,
  sessionStorageClient,
  userInfoStorageClient,
} from "./storage";

export const sessionClient: SessionClient = new SessionClientAdapter(
  sessionStorageClient,
  authTokenStorageClient,
  userInfoStorageClient,
);

const apiBaseUrl = `${process.env.VUE_APP_API_BASE_URL}api/`;

// Diferente do pro: usa o createAxiosClient do core (baseURL, timeout, headers,
// paramsSerializer e interceptors), como o psiapp-reactnative-user. O pro monta
// a instância na mão só para encaixar um mockInterceptor que o main não tem.
const axiosClient = createAxiosClient(apiBaseUrl, sessionClient);
const httpClient = new AxiosHttpClient(axiosClient);
export const api = new ApiServiceImpl(httpClient);
